document.documentElement.classList.remove("anti-flicker-hide");

function main() {
  const shopifyClient = createShopifyClient();
  const { ATOM_PRO_2_ID, ATOM_2_ID } = productConfig;

  const NewBuyNowButton = document.getElementsByClassName("button");

  function createShopifyClient() {
    return ShopifyBuy.buildClient({
      accessToken: "77582b62efde9c098c335a99908b43c7",
      domain: "audienhearing.com",
      appId: "60039036929",
    });
  }

  Array.from(NewBuyNowButton).forEach((button, index) => {
    button.addEventListener("click", () => {
      const productId = index === 0 || index === 2 ? ATOM_2_ID : ATOM_PRO_2_ID;
      handleCTAClick(shopifyClient, productId);
    });
  });

  function handleCTAClick(client, productId) {
    client.createCart().then((cart) => {
      client.fetchProduct(productId).then((product) => {
        cart
          .createLineItemsFromVariants({
            variant: product.variants[0],
            quantity: 1,
          })
          .then((updatedCart) => {
            window.location.href = updatedCart.checkoutUrl;
          });
      });
    });
  }
}

main();
